<template>
  <div>
    <v-bottom-sheet :value="value" persistent>
      <v-card>
        <div class="pl-2 pt-2">
          <v-btn icon small @click="handleCloseProductDetail">
            <v-icon>close</v-icon>
          </v-btn>
          <span class="title primary--text"> PRODUCT BUNDLED </span>
        </div>

        <v-card-text>
          <v-layout>
            <v-flex class="title">{{ product.name }}</v-flex>
            <v-flex shrink style="white-space: nowrap">
              จำนวนสินค้า
              {{ option && option[2] }} ชิ้น
            </v-flex>
          </v-layout>
          <div class="mt-2" v-if="product.productstock">
            <template v-for="(stype, sindex) in product.productstock">
              <v-chip
                :key="'stock_' + sindex"
                depressed
                @focus="
                  onViewStockPhoto(stype)
                  option = stype
                  quantity = 1
                "
                :disabled="parseInt(stype[2]) < 1"
                @click="onChangeOption(stype[1])"
                :dark="option && stype[0] == option[0]"
                :color="option && stype[0] == option[0] ? theme.color : ''"
              >
                <v-avatar v-if="stype[7]">
                  <img :src="stype[7]" :alt="stype[1]" />
                </v-avatar>
                {{ stype[1] }}
              </v-chip>
            </template>
          </div>
        </v-card-text>
        <v-layout align-center>
          <v-flex class="pl-2">{{ $t('Total') }}</v-flex>
          <v-flex shrink>
            <v-btn
              outline
              fab
              color="primary"
              @click="removeCount()"
              :disabled="quantity == 1"
              style="height: 30px; width: 30px"
              small
            >
              <v-icon small>mdi-minus</v-icon>
            </v-btn>
            <span
              class="text-center"
              style="
                width: 60px;
                display: inline-block;
                margin-left: 5px;
                margin-right: 5px;
                text-align: center;
              "
            >
              <v-text-field
                class="quantity text-center mt-2"
                outline
                box
                dense
                single-line
                hide-details
                :height="40"
                v-model="quantity"
                color="primary"
                @blur="changeQuantity"
              ></v-text-field
            ></span>

            <v-btn
              outline
              fab
              color="primary"
              @click="addCount()"
              style="height: 30px; width: 30px"
              small
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-btn
          block
          class="py-4"
          color="primary"
          :class="{ disabled: isOutOfStock }"
          :disabled="isOutOfStock || !option"
          @click="handleAddToCart"
          :loading="loading"
        >
          <v-icon>mdi-cart-plus</v-icon>&nbsp;
          <span>{{ $t('Add to cart') }}</span>
        </v-btn>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import ProductOption from '@/components/ecommerce/ProductOption'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: false
    },
    product: {
      value: undefined
    }
  },
  data() {
    return {
      currentOption: null,
      quantity: 1,
      option: null,
      loading: false
    }
  },
  components: {
    ProductOption
  },
  mounted() {
    this.setOption()
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    }),
    isOutOfStock: function () {
      const quantity =
        this.option && this.option.length ? parseInt(this.option[2]) : 0
      if (quantity) {
        if (quantity <= 0 || quantity < this.quantity) {
          return true
        } else {
          return false
        }
      }
      return true
    }
  },
  methods: {
    handleCloseProductDetail() {
      this.$emit('input', false)
    },
    addCount: function () {
      if (!this.option || this.option == null) {
        return false
      }
      if (this.quantity < this.option[2]) {
        this.quantity++
      }
    },
    removeCount: function () {
      if (this.quantity > 1) {
        this.quantity--
      }
    },
    changeQuantity(event) {
      if (event.target) {
        if (!this.option || this.option == null) {
          this.quantity = 1
        }
        try {
          if (parseInt(event.target.value) > this.option[2]) {
            this.quantity = this.option[2]
          }

          if (parseInt(event.target.value) < 1) {
            this.quantity = 1
          }
        } catch (error) {
          this.quantity = 1
        }
      }
    },
    onChangeOptionList(type) {
      const stock = type

      if (stock) {
        this.option = stock
        this.quantity = 1
      } else {
        this.option = null
        this.quantity = 1
      }
    },
    onChangeOption(type) {
      const stock = this.product.productstock.find((el) => {
        return el[1] == type
      })
      this.onChangeOptionList(stock)
    },
    focusOption() {},
    onViewStockPhoto() {},
    setOption() {
      this.option = null
      if (
        this.product &&
        this.product.productstock &&
        this.product.productstock.length > 0
      ) {
        try {
          const option = this.product.productstock.find((val) => {
            return val && parseInt(val[2]) > 0
          })

          if (option) {
            this.option = option
            this.currentOption = this.option[1]
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      }
    },
    async handleAddToCart() {
      const vm = this
      vm.quantity = parseInt(vm.quantity)

      if (vm.isOutOfStock) {
        return false
      }
      const result = await vm.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        return false
      }
      vm.loading = true

      const option = [...vm.option]
      const price = option[3] || vm.product.price
      const discountprice = option[4] || vm.product.discountprice

      let item = {
        ...vm.product,
        quantity: vm.quantity,
        option: option,
        photourl: option[7] ? option[7] : vm.product.photourl,
        price: price,
        discountprice: discountprice,
        weight: vm.product.weight ? vm.product.weight : 0
      }

      vm.setOption()

      vm.$emit('addToCart', {
        item: item,
        loading: async function () {
          vm.$emit('input', false)

          vm.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
